var _title, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 11",
    "aria-labelledby": "setinha1Icon setinha1Desc"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "icone de setinha")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "inherit",
    d: "M2.1 0L0 2.1 9 11l9-8.9L15.9 0 9 6.8 2.1 0z"
  })));
}

export default SvgArrow;